module.exports = __webpack_public_path__ + "static/img/CARRARA-VANILLA-STIX.3e5fe21.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CARRARA-VANILLA-STIX.png
// module id = /mHE
// module chunks = 0